<div class="preamble">
  <b>Be the Best.</b>
  Share TYT via social media, and receive recognition.

  <button (click)="showDialog()">
    What's a Mission?
  </button>
</div>

<div class="leaderboard">
  @if (state === 'loading') {
    @for (n of [].constructor(expectedCount); track n) {
      <a class="placeholder">
        <picture></picture>
        <span class="placeholder"></span>
        <span><span class="placeholder"></span></span>
        <span><span class="placeholder" style="width: 2em"></span></span>
      </a>
    }
  }

  @if (state === 'ready') {
    @for (item of entries; track item) {
      <a routerLink="/@{{item.user.username}}">
        <picture [responsiveBackgroundImage]="item.user.avatar"></picture>
        {{ item.user.display_name }}
        <span>&#64;{{item.user.username}}</span>
        <span>{{ item.share_count }}</span>
      </a>
    }
  }
</div>
